/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { ApplicationQuery } from "~/generated/graphql";
import { useCurrency } from "~/hooks";
import { formatMoneyWithFallback, isNotNil } from "~/tools";

export function useEnvironments(data: ApplicationQuery | undefined) {
  const { currency } = useCurrency();

  const mappedEnvironments = React.useMemo(() => {
    const environments = (data?.application?.environments ?? []).filter(
      isNotNil
    );

    return environments.map((environment) => ({
      environment: environment.name,
      id: environment.id,
      belongsTo: environment.orgUnitsV2?.orgUnits ?? [],
      resources: environment.resourceCount ?? 0,
      environmentType: environment.environmentType ?? "",
      actualCosts: formatMoneyWithFallback(
        environment.cost?.currentMonth,
        currency
      ),
      // Don't format it, value is used to for calculation inside components
      budget: environment.budgetYearly ?? undefined,
      forecast: formatMoneyWithFallback(environment.cost?.forecast, currency),
      cloudWasteAggregate: environment.cloudWasteAggregate ?? undefined,
    }));
  }, [data, currency]);

  return {
    environments: mappedEnvironments,
  };
}
